import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { colors } from '../../../../../../constants'

const Unknown = styled.span`
    color: ${colors.greylight};
    font-style: italic;
`

function WiredLabel({ wired }: { wired?: boolean | null}) {
    const { t } = useTranslation()

    if (typeof wired !== 'boolean') {
        return <Unknown>{t('device-status-unknown')}</Unknown>;
    }

    if (wired) {
        return t('device.wired.ethernet');
    }

    return t('device.wired.wifi');
}

export default WiredLabel
